import {isNil} from 'ramda';

import {createSubscriptionMessage} from '../utils/createSubscriptionMessage';
import {resetKeepAlive} from './resetKeepAlive';
import type {SocketContext, SubscriptionState} from './subscriptionTypes';

/**
 * Called on `connection_ack` (the AppSync transport handshake). Sends the
 * subscription `start` frame — this is what actually registers the subscription
 * server-side. Also arms the keep-alive with the server-negotiated timeout and
 * resets the transport-level backoff curve (transport is proven healthy).
 *
 * Does NOT clear the re-auth breaker — only `start_ack` proves authorization,
 * so that's where `clearReauthAttempts` lives.
 */
export const registerSubscription = (
  keepAliveTimeoutMs: number,
  state: SubscriptionState,
  ctx: SocketContext
) => {
  const subscriptionMessage = createSubscriptionMessage(ctx.subscriptionId);
  if (isNil(subscriptionMessage)) {
    return;
  }

  ctx.socket.send(JSON.stringify(subscriptionMessage));
  ctx.keepAliveTimeoutMs = keepAliveTimeoutMs;
  resetKeepAlive(ctx);

  state.reconnectAttempts = 0;
};
